// extracted by mini-css-extract-plugin
export default {"logout-container":"_admin-logout_logout-container__am0Dc","description":"_admin-logout_description__nd9uW"};